/** @file A command's description and form fields from describe_command's JSON Schema, cached per name. */
import { describeCommand } from '@pose2d/api/queries/describeCommand';
import { fieldsOf, type FieldSpec } from './schemaFields';

/** What CommandForm renders for one command. */
export interface CommandSchema {
  name: string;
  description: string;
  fields: readonly FieldSpec[];
}

const CACHE = new Map<string, CommandSchema>();

/** Throws NOT_FOUND (describeCommand) for an unregistered name; the registry is fixed per build, so no invalidation. */
export function commandSchema(name: string): CommandSchema {
  const hit = CACHE.get(name);
  if (hit) return hit;
  const described = describeCommand(name);
  const schema = { name: described.name, description: described.description, fields: fieldsOf(described.name, described.input) };
  CACHE.set(name, schema);
  return schema;
}
